// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-pop-up {
    width: 300px;
    display: flex;
    padding: 30px;
    align-items: center;
    border-radius: 10px;
    flex-direction: column;
    background-color: #FFFFFF;
}

.green-tick {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    border-radius: 50px;
    background-color: green;
    justify-content: center;
}

.red-tick {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    border-radius: 50px;
    background-color: red;
    justify-content: center;
}

.yellow-tick {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    border-radius: 50px;
    background-color: #F5C965;
    justify-content: center;
}

.green-tick img {
    width: 40px;
}

.red-tick img {
    width: 40px;
}

.success-pop-up p {
    margin: 0;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/payment-success-popup.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB","sourcesContent":[".success-pop-up {\n    width: 300px;\n    display: flex;\n    padding: 30px;\n    align-items: center;\n    border-radius: 10px;\n    flex-direction: column;\n    background-color: #FFFFFF;\n}\n\n.green-tick {\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    border-radius: 50px;\n    background-color: green;\n    justify-content: center;\n}\n\n.red-tick {\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    border-radius: 50px;\n    background-color: red;\n    justify-content: center;\n}\n\n.yellow-tick {\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    border-radius: 50px;\n    background-color: #F5C965;\n    justify-content: center;\n}\n\n.green-tick img {\n    width: 40px;\n}\n\n.red-tick img {\n    width: 40px;\n}\n\n.success-pop-up p {\n    margin: 0;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
